import React, { useState } from 'react';
import { LogoIcon, LogoutIcon, SparklesIcon, ImageIcon, VideoIcon, ScanIcon, ClipboardCheckIcon } from '../components/icons';
import ChatView from './ChatView';
import ImageGenerationView from './ImageGenerationView';
import VideoGenerationView from './VideoGenerationView';
import ImageAnalysisView from './ImageAnalysisView';
import CampaignReviewView from './CampaignReviewView';


interface DashboardViewProps {
  onDisconnect: () => void;
}

type Tab = 'chat' | 'image' | 'video' | 'analysis' | 'review';

const DashboardView: React.FC<DashboardViewProps> = ({ onDisconnect }) => {
    const [activeTab, setActiveTab] = useState<Tab>('chat');

    const tabs = [
        { id: 'chat', name: 'AI Marketing Chat', icon: SparklesIcon },
        { id: 'image', name: 'Image Generation', icon: ImageIcon },
        { id: 'video', name: 'Video Generation', icon: VideoIcon },
        { id: 'analysis', name: 'Image Analysis', icon: ScanIcon },
        { id: 'review', name: 'Campaign Review', icon: ClipboardCheckIcon },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case 'chat':
                return <ChatView />;
            case 'image':
                return <ImageGenerationView />;
            case 'video':
                return <VideoGenerationView />;
            case 'analysis':
                return <ImageAnalysisView />;
            case 'review':
                return <CampaignReviewView />;
            default:
                return null;
        }
    };

    return (
        <div className="flex flex-col h-screen">
            <header className="flex items-center justify-between p-4 bg-base-200 border-b border-base-300 flex-shrink-0">
                <div className="flex items-center gap-3">
                    <LogoIcon className="w-8 h-8 text-brand-primary" />
                    <h1 className="text-xl font-bold">QuantumLeap AI</h1>
                </div>
                <button onClick={onDisconnect} className="p-2 rounded-md hover:bg-base-300 transition-colors" aria-label="Disconnect">
                    <LogoutIcon className="w-6 h-6 text-text-secondary"/>
                </button>
            </header>
            
            <nav className="flex-shrink-0 bg-base-200 border-b border-base-300">
                <div className="flex items-center justify-center space-x-1 sm:space-x-4 p-2">
                    {tabs.map(tab => {
                        const Icon = tab.icon;
                        const isActive = activeTab === tab.id;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id as Tab)}
                                className={`flex items-center justify-center sm:justify-start gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                                    isActive 
                                    ? 'bg-brand-primary text-white' 
                                    : 'text-text-secondary hover:bg-base-300 hover:text-text-primary'
                                }`}
                                aria-current={isActive ? 'page' : undefined}
                            >
                                <Icon className="w-5 h-5" />
                                <span className="hidden sm:inline">{tab.name}</span>
                            </button>
                        );
                    })}
                </div>
            </nav>

            <main className="flex-1 overflow-y-auto">
                {renderContent()}
            </main>
        </div>
    );
};

export default DashboardView;
